import React from 'react';
import { BrokerConfigDto, FlowConfiguration } from '../../../../../../../types/rest/mockServiceTypes';
import { Col, Form, Row } from 'react-bootstrap';
import MultipleSelect, { MultipleSelectItem } from '../../../../../../../components/selectors/MultipleSelect';
import { getMappingItems } from '../../../../../../../utils/messagingUtils';
import _ from 'lodash';
import BzmIcon from '../../../../../../../components/icons/BzmIcon';
import clsx from 'clsx';

type ItemProps = {
  item: FlowConfiguration; // Adjust this type to match the shape of the items you're rendering
  onChange: (item: FlowConfiguration) => void;
  /** Optional label for form controls. */
  label?: string;
  disabled?: boolean;
  metadata?: BrokerConfigDto;
};

const FlowConfigurationItem = ({ item, onChange, label, disabled, metadata }: ItemProps) => {
  const getSelectedSource = (): MultipleSelectItem => {
    if (item.transactionMapping && item.transactionMapping.sourceName) {
      const sourceName = item.transactionMapping.sourceName;
      return { label: sourceName, value: sourceName };
    }
  };

  const getSelectedDestinations = (): MultipleSelectItem[] => {
    if (item.transactionMapping && item.transactionMapping.destinations) {
      return _.map(item.transactionMapping.destinations, destination => {
        return {
          label: destination.destinationName,
          value: destination.destinationName,
          metadata: { type: destination.destinationType },
        };
      });
    }
  };

  return (
    <Row>
      <Col>
        {label && <label>Flow Name</label>}
        <Form.Control
          disabled={disabled}
          value={item.name}
          onChange={e => {
            onChange({ ...item, name: e.target.value });
          }}
        />
      </Col>
      <Col md={3}>
        {label && <label>Inbound Destination</label>}
        <MultipleSelect
          onChange={multiSelectItem => {
            const update = multiSelectItem as MultipleSelectItem;
            const transactionMapping = {
              sourceName: update.value,
              sourceType: update.metadata.type,
              destinations: item.transactionMapping?.destinations || [],
            };

            onChange({ ...item, transactionMapping });
          }}
          items={getMappingItems(metadata)}
          selected={getSelectedSource()}
          readonly={disabled}
          placeholder={'Choose inbound queue / topic'}
          isMulti={false}
        />
      </Col>

      <Col md="auto" className={clsx('text-center', label ? 'pt-6' : 'pt-3')}>
        <BzmIcon variant={'icon-bzm-arrow-right'} />
      </Col>

      <Col md={3}>
        {label && <label>Outbound Destination</label>}
        <MultipleSelect
          onChange={multiSelectItem => {
            const update = multiSelectItem as MultipleSelectItem[];
            const transactionMapping = {
              ...item.transactionMapping,
              destinations:
                _.map(update, destination => {
                  return {
                    destinationName: destination.value,
                    destinationType: destination.metadata.type,
                  };
                }) || [],
            };

            onChange({ ...item, transactionMapping });
          }}
          items={getMappingItems(metadata)}
          selected={getSelectedDestinations()}
          readonly={disabled}
          placeholder={'Choose outbound queue / topic'}
          isMulti={true}
        />
      </Col>
    </Row>
  );
};

export default FlowConfigurationItem;
